module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/past-projects/tsb-finding-purpose-3771649b615b0cb6aa399452b7d4ebf0.jpg";